// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Grants_grants__8T-Dx .Grants_grant__3jVh7 {
  margin-bottom: 25px;
  background: white;
  padding: 15px 20px;
  border-radius: 5px;
}
.Grants_grants__8T-Dx .Grants_grant__3jVh7 .Grants_section-title__\\+1\\+6P {
  color: var(--dark-grey);
  font-weight: 500;
  font-size: 14px;
}
.Grants_grants__8T-Dx .Grants_grant__3jVh7 .Grants_title__ii36Y:hover {
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}
@media only screen and (max-width: 480px) {
  .Grants_grants__8T-Dx .Grants_section-title__\\+1\\+6P {
    text-decoration: underline;
  }
}`, "",{"version":3,"sources":["webpack://./src/Admin/Pages/PersonalProfile/Components/Grants/Grants.module.scss"],"names":[],"mappings":"AACE;EACE,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AAAJ;AACI;EACE,uBAAA;EACA,gBAAA;EACA,eAAA;AACN;AACI;EACE,WAAA;EACA,0BAAA;EACA,eAAA;AACN;AAEE;EACE;IACE,0BAAA;EAAJ;AACF","sourcesContent":[".grants {\n  .grant {\n    margin-bottom: 25px;\n    background: white;\n    padding: 15px 20px;\n    border-radius: 5px;\n    .section-title {\n      color: var(--dark-grey);\n      font-weight: 500;\n      font-size: 14px;\n    }\n    .title:hover {\n      color: blue;\n      text-decoration: underline;\n      cursor: pointer;\n    }\n  }\n  @media only screen and (max-width: 480px) {\n    .section-title {\n      text-decoration: underline;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grants": `Grants_grants__8T-Dx`,
	"grant": `Grants_grant__3jVh7`,
	"section-title": `Grants_section-title__+1+6P`,
	"title": `Grants_title__ii36Y`
};
export default ___CSS_LOADER_EXPORT___;
